export enum VIEW_TYPE {
  questionAnswer = 'questionAnswer',
  showPlan = 'showPlan',
  chat = 'chat',
}

const salaryIncomeChoices = [
  {
    id: 'singleForm16OrSalaryLessThanFiftyLacs',
    title: 'Single Form 16 or Salary less than 50 lakhs',
    desc: '',
    planId: ['prod_itr_salary_prime_l', 'prod_itr_salary_live_l'],
    viewType: VIEW_TYPE.showPlan,
  },
  {
    id: 'multipleForm16OrSalaryMoreThanFiftyLacs',
    title: 'Multiple Form 16s / Switched jobs or Salary more than 50 lakhs',
    desc: '',
    planId: ['prod_itr_salary_premium_l', 'prod_itr_salary_live_l'],
    viewType: VIEW_TYPE.showPlan,
  },
];

const cryptoChoices = [
  {
    id: 'cryptoIncomeFromTradingPresent',
    title: 'Income from crypto trading',
    desc: '',
    planId: ['prod_cryptocurrency_filing_Traders_l'],
    viewType: VIEW_TYPE.showPlan,
  },
  {
    id: 'cryptoIncomeFromMiningPresent',
    title: 'Income from crypto mining',
    desc: '',
    planId: ['prod_cryptocurrency_filing_Business_Premium_l'],
    viewType: VIEW_TYPE.showPlan,
  },
];

const capitalGainsChoices = [
  {
    id: 'capitalGainIntraDayPresent',
    title: 'I have income from intraday / F&O trading',
    desc: '',
    planId: ['prod_traders_l', 'prod_itr_comprehensive_live_l'],
    viewType: VIEW_TYPE.showPlan,
  },
  {
    id: 'capitalGainNoIntraDayPresent',
    title: "I don't have income from intraday / F&O trading",
    desc: '',
    planId: ['prod_itr_comprehensive_plan_l', 'prod_itr_comprehensive_live_l'],
    viewType: VIEW_TYPE.showPlan,
  },
];

const businessChoices = [
  {
    id: 'businessIncomeBelowTurnOver',
    title: 'Annual turnover is < 2 Cr or gross receipt < 50 lakhs',
    desc: '',
    planId: ['prod_itr_presumptive_l', 'prod_itr_premium_live_l'],
    viewType: VIEW_TYPE.showPlan,
  },
  {
    id: 'businessIncomeExceedsTurnOver',
    title: 'Annual turnover is > 2 Cr or gross receipt > 50 lakhs',
    desc: '',
    planId: ['prod_itr_premium_l', 'prod_itr_premium_live_l'],
    viewType: VIEW_TYPE.showPlan,
  },
];

export const salaryIncomeQuestion = {
  questionId: 'q2',
  id: 'salaryIncomeQuestion',
  question: 'Tell us more',
  desc: 'Please select options as per your income and we will suggest the best plan for you!',
  type: 'radio',
  answers: salaryIncomeChoices,
};

const capitalGainsQuestion = {
  questionId: 'q2',
  id: 'capitalGainsQuestion',
  question: 'Tell us more',
  desc: 'Please select options as per your income and we will suggest the best plan for you!',
  type: 'radio',
  answers: capitalGainsChoices,
};

const businessQuestion = {
  questionId: 'q2',
  id: 'businessQuestion',
  question: 'Tell us more',
  desc: 'Please select options as per your income and we will suggest the best plan for you!',
  type: 'radio',
  answers: businessChoices,
};

const cryptoQuestion = {
  questionId: 'q2',
  id: 'cryptoQuestion',
  question: 'Tell us more',
  desc: 'Please select options as per your income and we will suggest the best plan for you!',
  type: 'radio',
  answers: cryptoChoices,
};

export const question1 = {
  questionId: 'q1', // 'q1' is the id of the first question
  id: 'q1',
  question: 'Which income category do you belong to?',
  desc: 'Help us understand your sources of income so we can pick the best plan for you',
  answers: [
    {
      id: 'salaryIncome',
      title: 'Salary Income',
      desc: 'One or multiple Form 16s ',
      nextQuestionId: salaryIncomeQuestion,
      priority: 7,
      viewType: VIEW_TYPE.questionAnswer,
    },
    {
      id: 'capitalGains',
      desc: 'Income from mutual funds, stocks, F&O or intraday trading, property/land, etc',
      title: 'Capital Gains',
      nextQuestionId: capitalGainsQuestion,
      priority: 6,
      viewType: VIEW_TYPE.questionAnswer,
    },
    {
      id: 'esopsRsusPresent',
      desc: 'Income from sale of ESOPs and/or RSUs',
      title: 'ESOPs & RSUs',
      planId: ['prod_itr_esop_rsu_l', 'prod_itr_comprehensive_live_l'],
      priority: 5,
      viewType: VIEW_TYPE.showPlan,
    },
    {
      id: 'business',
      desc: 'Income from business, professionals, or freelance gigs',
      title: 'Business income/Freelance income',
      nextQuestionId: businessQuestion,
      priority: 4,
      viewType: VIEW_TYPE.questionAnswer,
    },
    {
      id: 'rentalIncomePresent',
      desc: 'Income from renting of property, Withdrawal from PF & bank deposits',
      title: 'Rental income/Income from interest',
      planId: ['prod_itr_salary_prime_l', 'prod_itr_salary_live_l'],
      priority: 8,
      viewType: VIEW_TYPE.showPlan,
    },
    {
      id: 'inComeFromForeignSourcesPresent',
      desc: 'I am an NRI / I have Income earned for NRE/NRO accounts ',
      title: 'Income from foreign sources ',
      planId: ['prod_itr_global_citizen_Premium_l', 'prod_itr_nri_live_l'],
      priority: 1,
      viewType: VIEW_TYPE.showPlan,
    },
    {
      id: 'cryptoTrading',
      desc: 'Income from crypto trading/mining',
      title: 'Crypto trading',
      nextQuestionId: cryptoQuestion,
      priority: 3,
      viewType: VIEW_TYPE.questionAnswer,
    },

    {
      id: 'otherIncomePresent',
      desc: 'Any type of income',
      title: 'Others',
      priority: 0,
      viewType: VIEW_TYPE.chat,
    },
  ],
};
export const QnA = {
  questions: [
    question1,
    salaryIncomeQuestion,
    capitalGainsQuestion,
    businessQuestion,
    cryptoQuestion,
  ],
};

export const getHighestPriorityObject = (
  ids: string[] | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  objArray: any[]
) => {
  if (!ids || ids.length === 0) {
    return null;
  }

  let highestPriorityOption = null;
  const selectedOptionsInPriority = [];

  for (const id of ids) {
    const matchedObj = objArray.find((item) => item.id === id);

    if (matchedObj) {
      selectedOptionsInPriority.push(matchedObj);
      if (
        !highestPriorityOption ||
        matchedObj.priority < highestPriorityOption.priority
      ) {
        highestPriorityOption = matchedObj;
      }
    }
  }
  selectedOptionsInPriority.sort((a, b) => a.priority - b.priority);
  return { highestPriorityOption, selectedOptionsInPriority };
};

export const getChildQuestionId = (
  id: string | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  objArray: any[]
) => {
  const matchedObj = objArray.find((item) => item.id === id);

  return matchedObj.nextQuestionId?.id;
};

export const transformSelectedAnswersToObject = (
  input: Record<string, string[]>
) => {
  const result: Record<string, boolean> = {};
  for (const key in input) {
    input[key]?.forEach((item) => {
      result[item] = true;
    });
  }
  return result;
};
